module.exports = __webpack_public_path__ + "static/img/GB-NIR.7aabc790.svg";